export default "__VITE_ASSET__6971a402__"